<template>
	<div class="form-inputs">
		<FormLabelTooltip
			:required="required"
			:name="`select-${name}`"
			:label="label"
		/>
		<label class="wrapper">
			<select
				class="b360-form-input"
				:class="selectStateStyles"
				v-model="selectedOption"
				@change="
					(event) => {
						$emit('input', { fieldName: name, value: event.target.value });
					}
				"
				:id="`select-${name}`"
				:required="required"
				:disabled="disabled"
				:style="`font-family: ${selectedOption}`"
			>
				<option
					v-for="(option, index) in options"
					:value="option"
					:key="index"
					:style="`font-family: ${option}`"
				>
					{{ option }}
				</option>
			</select>
		</label>
	</div>
</template>

<script>
import FormLabelTooltip from '@/components/global/FormLabelTooltip.vue';

export default {
	name: 'FontDropdown',
	components: {
		FormLabelTooltip,
	},
	props: {
		name: String,
		label: String,
		placeholder: String,
		required: Boolean,
		options: Array,
		value: null,
		disabled: Boolean,
		error: null,
	},
	data() {
		return {
			selectedOption: null,
		};
	},
	mounted() {
		this.selectedOption = this.value || this.options[0];
	},
	watch: {
		value(newValue) {
			this.selectedOption = newValue || this.options[0];
		},
	},
	computed: {
		selectStateStyles() {
			return {
				'b360-form-input--disabled': this.disabled,
				error: this.error,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
select.b360-form-input {
	height: 44px;
	padding: 0.6rem 0.75rem;
	-webkit-appearance: none !important;
	-moz-appearance: none !important;
	appearance: none !important;

	&--disabled {
		color: #555;
		background-color: #f5f5f5;
	}
}
.wrapper {
	&:after {
		content: '\25BC';
		@include rem(width, 10px);
		@include rem(height, 10px);
		background: #fff;
		display: block;
		position: relative;
		text-align: center;
		color: #000;
		font-size: 10px;
		bottom: 30px;
		left: 96%;
		z-index: 1;
	}
}
.error {
	border: 1px solid $error;
}
</style>
